export function takeUntil<T>(list: T[], predicate: (t: T) => boolean) {
  const newList: T[] = [];
  let i = 0;
  while (i < list.length && predicate(list[i])) {
    newList.push(list[i]);
    i++;
  }
  return newList;
}

export function chunk<T>(list: T[], size: number): T[][] {
  const chunkCount = Math.ceil(list.length / size);
  return new Array(chunkCount).fill(null).map((_c: null, i: number) => {
    return list.slice(i * size, i * size + size);
  });
}

export function shuffle<T>(list: T[]): T[] {
  return list.sort(() => 0.5 - Math.random());
}

export function sliding<T>(list: T[], windowSize: number): T[][] {
  if (windowSize < 1) {
    throw new Error("window size cannot be smaller then 1");
  }
  windowSize = Math.floor(windowSize);
  if (windowSize > list.length) {
    throw new Error("window size cannot be larger then list size");
  }
  return new Array(list.length - (windowSize - 1))
    .fill(null)
    .map((_c: null, i: number) => {
      return list.slice(i, i + windowSize);
    });
}
